let defaultCollapse = false;
let defaultAccessToken = '';
let defaultRefreshToken = '';
let default_user_info={};
let default_int_no='';
let default_user_menus = [];
let default_user_roles = [];
let default_user_permissions = [];

try {
    if (sessionStorage.isCollapse) {
        if (sessionStorage.isCollapse === 'true') {
            defaultCollapse = true;
        } else {
            defaultCollapse = false;
        }
    }

    if (localStorage.getItem('access_token')) {
        defaultAccessToken=localStorage.getItem('access_token');

    }

    if (localStorage.getItem('refresh_token')) {
        defaultRefreshToken=localStorage.getItem('refresh_token');

    }

    if (localStorage.getItem('user_info')) {
        default_user_info=JSON.parse(localStorage.getItem('user_info'));
    }

    if (localStorage.getItem('user_menus')) {
        default_user_menus=JSON.parse(localStorage.getItem('user_menus'));
    }

    if (localStorage.getItem('user_roles')) {
        default_user_roles=JSON.parse(localStorage.getItem('user_roles'));
    }

    if (localStorage.getItem('user_permissions')) {
        default_user_permissions=JSON.parse(localStorage.getItem('user_permissions'));
    }

// eslint-disable-next-line no-empty
} catch (e) {
}

try {
    if (sessionStorage.getItem('int_no')) {
        default_int_no=sessionStorage.getItem('int_no')
    }

// eslint-disable-next-line no-empty
} catch (e) {
}


export default {
    isCollapse: defaultCollapse,
    access_token: defaultAccessToken,
    refresh_token: defaultRefreshToken,
    user_info:default_user_info,
    int_no:default_int_no, //邀请码
    userMenus: default_user_menus, // 用户菜单
    userRoles: default_user_roles, // 用户角色
    userPermissions: default_user_permissions, // 用户权限
}
